import AttachmentTable from './AttachmentsTable';
import { SideSheet, SideSheetHeader } from '../../../layouts';
import { formatDayJsDate } from '../../../utils/dateTimeUtils';
import { convertDateToDayJs } from '../../../utils/dateTimeUtils';
import { getFormattedAmount } from '../../../utils/form';

interface PerDiemLineItemDetailsProps {
  isOpen: boolean;
  onClose: () => void;
  lineItemData: any;
  attachments: any[];
  travelRequestId: number;
  formConfig: any;
  headerChildren?: React.ReactNode;
}

function GridDataPoint({
  config,
}: {
  config: { label: string; value: React.ReactNode };
}) {
  const { label, value } = config;
  return (
    <div className="flex flex-col gap-y-1">
      <div className="font-semibold text-text-200 text-xs">{label}</div>
      <div className="font-normal text-text-400 text-xs">{value}</div>
    </div>
  );
}

const PerDiemLineItemDetails = ({
  isOpen,
  onClose,
  lineItemData,
  attachments,
  travelRequestId,
  formConfig,
  headerChildren,
}: PerDiemLineItemDetailsProps) => {
  if (!isOpen) return null;
  const fields = formConfig?.perDiemForm?.fields;

  return (
    <SideSheet
      closeOnClickOutside={true}
      isOpen={isOpen}
              addOnClass="w-full max-w-none md:!w-[50vw]"
      onClose={onClose}
      contentChildren={
        <div className="flex flex-col gap-4 p-3">
          {lineItemData && (
            <div className="flex flex-col gap-3">
              <div className="grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-3">
                {fields?.city?.visible && (
                  <GridDataPoint
                    config={{
                      label:
                        fields?.city?.label ||
                        fields?.city?.defaultLabel ||
                        'City',
                      value:
                        lineItemData.city?.label ||
                        lineItemData.travelToCity?.ShortDescription ||
                        '-',
                    }}
                  />
                )}
                {fields?.fromDate?.visible && (
                  <GridDataPoint
                    config={{
                      label:
                        fields?.fromDate?.label ||
                        fields?.fromDate?.defaultLabel ||
                        'From Date',
                      value: lineItemData.fromDate
                        ? formatDayJsDate(
                            convertDateToDayJs(lineItemData.fromDate),
                          )
                        : '-',
                    }}
                  />
                )}
                {fields?.toDate?.visible && (
                  <GridDataPoint
                    config={{
                      label:
                        fields?.toDate?.label ||
                        fields?.toDate?.defaultLabel ||
                        'To Date',
                      value: lineItemData.toDate
                        ? formatDayJsDate(
                            convertDateToDayJs(lineItemData.toDate),
                          )
                        : '-',
                    }}
                  />
                )}
                {fields?.noOfDays?.visible && (
                  <GridDataPoint
                    config={{
                      label:
                        fields?.noOfDays?.label ||
                        fields?.noOfDays?.defaultLabel ||
                        'No of Days',
                      value: lineItemData.noOfDays?.toString() || '-',
                    }}
                  />
                )}
                {fields?.rate?.visible && (
                  <GridDataPoint
                    config={{
                      label:
                        fields?.rate?.label ||
                        fields?.rate?.defaultLabel ||
                        'Rate',
                      value: lineItemData.rate
                        ? getFormattedAmount(lineItemData.rate)
                        : '-',
                    }}
                  />
                )}
                {fields?.total?.visible && (
                  <GridDataPoint
                    config={{
                      label:
                        fields?.total?.label ||
                        fields?.total?.defaultLabel ||
                        'Total',
                      value: lineItemData.total
                        ? getFormattedAmount(lineItemData.total)
                        : '-',
                    }}
                  />
                )}
                {fields?.remarks?.visible && (
                  <GridDataPoint
                    config={{
                      label:
                        fields?.remarks?.label ||
                        fields?.remarks?.defaultLabel ||
                        'Remarks',
                      value: lineItemData.remarks || '-',
                    }}
                  />
                )}
              </div>
            </div>
          )}

          <div className="flex flex-col gap-3">
            <h2 className="text-md">Attachments</h2>
            <AttachmentTable
              attachments={attachments || []}
              travelRequestId={travelRequestId}
            />
          </div>
        </div>
      }
      headerChildren={
        <div className="border-b border-gray-100">
          {headerChildren || (
            <SideSheetHeader title="Per Diem Details" onCloseClick={onClose} />
          )}
        </div>
      }
      footerChildren={<></>}
    />
  );
};

export default PerDiemLineItemDetails;
